export default "__VITE_ASSET__62002e07__"